import {writable} from 'svelte/store';

import {currentCountry as geocodeCurrentCountry} from '../geocode';

export const currentCountry = writable(geocodeCurrentCountry());
